const LightTheme = {
  colors: {
    background: '#f4f5fa',
    error: '#BF616A',
    info: '#1E88E5',
    'on-background': '#1a1a1a',
    'on-surface': '#1a1a1a',
    primary: '#4B55B5',
    secondary: '#7986CB',
    success: '#43A047',
    surface: '#FFFFFF',
    warning: '#FB8C00',
  },
  dark: false,
}

const BeigeTheme = {
  colors: {
    background: '#f5f0e8',
    error: '#BF616A',
    info: '#1E88E5',
    'on-background': '#3E2C1A',
    'on-surface': '#3E2C1A',
    primary: '#8B6914',
    secondary: '#A68A4B',
    success: '#43A047',
    surface: '#faf6ef',
    warning: '#E8A317',
  },
  dark: false,
}

const GreyTheme = {
  colors: {
    background: '#ECEFF1',
    error: '#BF616A',
    info: '#1E88E5',
    'on-background': '#212121',
    'on-surface': '#212121',
    primary: '#455A64',
    secondary: '#78909C',
    success: '#43A047',
    surface: '#F5F5F5',
    warning: '#FB8C00',
  },
  dark: false,
}

const MidnightTheme = {
  colors: {
    background: '#0d1117',
    error: '#D4878F',
    info: '#42A5F5',
    'on-background': '#e6edf3',
    'on-surface': '#e6edf3',
    primary: '#8B949E',
    secondary: '#B1BAC4',
    success: '#66BB6A',
    surface: '#161b22',
    warning: '#FFA726',
  },
  dark: true,
}

export { BeigeTheme, GreyTheme, LightTheme, MidnightTheme }
